<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>彩信</li>
                <li><a href="#">彩信草稿箱</a></li>
            </ul>
        </div>
    
        <div class="rightinfo">
            <div class="tools">
                <el-button type="primary" @click="plDelMmsDraft()" ><span class="f14">批量删除</span></el-button> 
            </div> 
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <table class="tablelist">
                <thead>
                <tr>
                    <th><input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/></th>
                    <th>接收者</th>
                    <th>彩信名称</th>
                    <th>编辑时间 </th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in mmsDraftList" :class="{odd:index%2!=0}">
                    <td style="width:4%;"><input name="selCheck" id="selCheck"  type="checkbox" :value="item.id" /></td>
                    <td style="width:20%;">{{item.mobile}}</td>
                    <td style="width:50%;">{{item.mmsSubject}}</td>
                    <td style="width:16%;">{{item.createTime}}</td>
                    <td style="width:10%;">
                        <a href="#" @click="gosmssend(item.mobile,item.mmsSubject)" class="tablelink">发送</a> 
                        <a href="#" class="tablelink" @click="delMmsDraft(item.id)">删除</a>
                    </td>
                </tr>          
                </tbody>
            </table>  
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>  
            <div class="jian">&nbsp;</div>    
        </div> 
    
        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{            
            pageIndex:0,
            totalCount:0,
            mmsDraftList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/pagemmsdraft.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.mmsDraftList = res.data.mmsDraftList;
                    that.pageIndex = parseInt(pageIndex);
                    // that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        gosmssend(mobile,content){            
            this.$router.push({
                path: '/mmssend',   
                query: {
                    mobile: mobile,
                    content: content
                }
            })
        },
        delMmsDraft(id){
            let that = this;
            let data = {'ids':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmsdraft.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("删除信息成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changAllCheck(){
            var checkers = document.getElementsByName('selCheck');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        plDelMmsDraft(){
            var ids = '';
            var checkers = document.getElementsByName('selCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(ids =='')
                        ids = checkers[i].value;
                    else
                        ids = ids + ',' + checkers[i].value;
                }
            }
            if(ids == ''){
                alert("请选择要删除的项！");
                return;
            }
            let that = this;
            let data = {'ids':ids};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmslog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("删除信息成功！");
                    that.pageChange(1);
                    that.cancelChecke();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        cancelChecke(){
            if(document.getElementById("allCheck").checked == true)
                document.getElementById("allCheck").checked = false;

            var checkers = document.getElementsByName('selCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    checkers[i].checked = false;
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mms/mmsdraft.vue